import { DocumentNode, gql } from '@apollo/client/core';
import { ITagContextMatchesParams } from '../utils';

export const GET_APP_CHECKOUT_SUGGESTIONS: DocumentNode = gql`
  query GetAppCheckoutSuggestions(
    $tags: Tags
    $isAuthenticated: Boolean!
    $orders: Int
    $previewUrl: String
  ) {
    getAppCheckoutSuggestionsPage(
      tags: $tags
      isAuthenticated: $isAuthenticated
      orders: $orders
      previewUrl: $previewUrl
    ) {
      uid
      condition
      feature_flag_key
      header_title
      ab_test_header_title
      group {
        uid
        slice_type
        items
        primary
      }
      ab_test_group {
        uid
        slice_type
        items
        primary
      }
    }
  }
`;

export type GetAppCheckoutSuggestionsQueryResult = {
  getAppCheckoutSuggestionsPage: {
    uid: string;
    condition: string | null;
    feature_flag_key: string | null;
    header_title: string | null;
    ab_test_header_title: string | null;
    group: [];
    ab_test_group: [];
  };
};

export type GetAppCheckoutSuggestionsQueryVariables = Omit<
  ITagContextMatchesParams,
  'isMember' | 'isAppNative' | 'isWebMobile'
> & {
  previewUrl?: string;
};
